import { get } from "@app/common/api";
import { ApiServiceStatus } from "@app/common/types/serviceStatusTypes";
import { camelizeKeys } from "@app/utils/utils";

/**
 * Fetches service status
 * @returns service status object to display to users
 * */
export const getServiceStatus = async (): Promise<ApiServiceStatus> => {
  const response = await get("/public/service-status");

  if (typeof response === "string") {
    return camelizeKeys(JSON.parse(response));
  }
  return response;
};
